import { render, staticRenderFns } from "./Minfadian.vue?vue&type=template&id=2dc369b6&scoped=true"
import script from "./Minfadian.vue?vue&type=script&lang=js"
export * from "./Minfadian.vue?vue&type=script&lang=js"
import style0 from "./Minfadian.vue?vue&type=style&index=0&id=2dc369b6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc369b6",
  null
  
)

export default component.exports